import * as ScoreType from 'constants/ScoreType';

export function getMainScore(scores) {
    const mainScoreId = scores.getIn([ScoreType.Match, 'id']);
    if (mainScoreId) {
        return mainScoreId;
    }

    return null;
}



// WEBPACK FOOTER //
// ./js/shared/adapters/MatchScoresAdapter.js